import { SwaggerException } from '../sdk/sdk';
import { problemDetailMessage, problemObjectMessage } from './problem-detail';

/**
 * Statuses whose body is a message meant for the user rather than a stack trace. 403 is here
 * because a permission refusal is the one 4xx the user cannot resolve by correcting the form:
 * without the server's sentence they get a generic "please try again", which is wrong for a denial
 * and hides the case where the permission check merely failed and retrying WOULD work.
 */
const SHOWABLE_STATUSES = [400, 403, 409] as const;

export function apiErrorMessage(err: unknown, fallback: string, logLabel: string): string {
  const message = serverMessage(err);
  if (message) return message;
  console.error(logLabel, err);
  return fallback;
}

/**
 * One generated client throws two shapes. For a status it was never told about it throws a
 * SwaggerException carrying the raw body; for a declared error response it throws the PARSED body
 * object instead. Reading only the first shape means every documented 409 -- which is every ACR
 * conflict -- reaches the user as the generic fallback.
 */
function serverMessage(err: unknown): string | null {
  if (err == null) return null;

  if (SwaggerException.isSwaggerException(err)) {
    return showableStatus(err.status) ? problemDetailMessage(err.response) : null;
  }

  return problemObjectMessage(err, SHOWABLE_STATUSES);
}

function showableStatus(status: number): boolean {
  return (SHOWABLE_STATUSES as readonly number[]).includes(status);
}
